import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimoniales',
  templateUrl: './testimoniales.component.html',
  styleUrls: ['./testimoniales.component.css']
})
export class TestimonialesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
